module.exports = __webpack_public_path__ + "img/facebook.8bc9913c.svg";